// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"145397ac1223a59a0775","453":"5f9795698f1d8de28000","522":"e0d52ba8da1a62e8ec70"}[chunkId] + ".js";
};